var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"photo-container"},[(_vm.situation && _vm.situation.media)?_c('div',[(_vm.filename)?_c('img',{staticClass:"photo",attrs:{"src":_vm.filename}}):_vm._e()]):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }